import { fetch } from "../lib/network";
import decamelizeKeys from "decamelize-keys";
import AppSettings from "../config";
import camelcaseKeys from "camelcase-keys";

export const getConversation = (networkHeaders: any) => (commentable_id: number | string, commentable_type: string) =>
  fetch(
    `${AppSettings.COMMENTS_API_URL}/conversation?commentable_id=${commentable_id}&commentable_type=${commentable_type}`,
    {
      method: "GET",
      headers: networkHeaders,
    },
  )
    .then((res) => res.json())
    .then((res) => camelcaseKeys(res, { deep: true }));

export const getComments = (networkHeaders: any, queryParams: any) => () =>
  fetch(`${AppSettings.COMMENTS_API_URL}?${queryParams}`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const getComment = (networkHeaders: any) => (key: any, id: string) =>
  fetch(`${AppSettings.COMMENTS_API_URL}/${id}`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const putComment = (networkHeaders: any, id: string) => (body: any) =>
  fetch(`${AppSettings.COMMENTS_API_URL}/${id}`, {
    method: "PUT",
    headers: networkHeaders,
    body: JSON.stringify({ data: { attributes: decamelizeKeys(body, "-") } }),
  });

export const postComment = (networkHeaders: any) => (body: any) =>
  fetch(`${AppSettings.COMMENTS_API_URL}`, {
    method: "POST",
    headers: networkHeaders,
    body: JSON.stringify({ data: { attributes: decamelizeKeys(body, "-") } }),
  });
